<template>
  <div>
    <v-row class="px-1 mt-1">
      <v-col cols="12" class="ma-0 mt-1 pt-0 pb-0 mb-0" v-if="paymentMethod.manage_positive_balance">
        <v-alert color="blue" class="mt-0 mb-1 alerta-pos" dark dense v-if="paymentMethod.manage_positive_balance">
          <v-row class="">
            <v-col class="text-left">
              <span class="title font-weight-medium">{{ $t('positive_balance') }}: </span>
            </v-col>
            <v-col class="text-right">
              <span class="title font-weight-regular">{{ $filters.currency(positiveBalance, 0) }}</span>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
      <v-col cols="12" class="ma-0 mt-1 mb-0 pt-0 pb-0" v-if="paymentMethod.need_reference">
        <ng-number-keyboard :label="$t('reference')" rules="required" :filled="false" :dense="false" show-required="true"
          v-model="reference" :disabled="orderNoBalance()"></ng-number-keyboard>
      </v-col>
    </v-row>
    <v-row class="px-1 mt-1 mb-1">
      <v-col cols="12" class="ma-0 pt-0 ">
        <div class="teclado__sugeridos" v-if="paymentMethod.manage_change && sugeridos.length">
          <span class="teclado__titulo">Recibe en efectivo</span>
          <div class="teclado__fila">
            <v-btn v-for="v in sugeridos" :key="'sug' + v" class="teclado__sug-btn" depressed color="primary" outlined
              :disabled="orderNoBalance()" @click="recibir(v)" :title="$t('add') + ' ' + $filters.currency(v, 0)">
              <span class="teclado__sug">
                <span class="teclado__sug-valor">{{ $filters.currency(v, 0) }}</span>
                <small>{{ v === order.getBalance() ? "Justo, sin cambio" : "Cambio " + $filters.currency(v - order.getBalance(), 0) }}</small>
              </span>
            </v-btn>
          </div>
        </div>
        <div class="teclado__billetes">
          <v-btn v-for="v in billetes" :key="'bil' + v" :small="is_mobile" :large="!is_mobile" elevation="2" :disabled="orderNoBalance()"
            @click="addTotalPayment(paymentMethod, v)" :title="$t('add') + ' ' + $filters.currency(v, 0)">
            {{ $filters.currency(v, 0) }}
          </v-btn>
          <v-btn :small="is_mobile" :large="!is_mobile" elevation="2" :disabled="orderNoBalance()" @click="cleanTotalPayment(paymentMethod)"
            :title="$t('erase')"><v-icon>mdi-backspace-outline</v-icon></v-btn>
        </div>
        <v-row class="px-1 mt-0">
          <v-col cols="12" sm="12" md="12" class="ma-0 pb-0">
            <v-alert color="grey lighten-4" dense class="ma-0 black--text teclado__monto">
              <div v-if="!editandoMonto" class="teclado__monto-fila">
                <span class="title font-weight-medium">{{ $t('amount') }}: </span>
                <v-spacer></v-spacer>
                <span class="title font-weight-regular">{{ $filters.currency(totalPayment, 0) }}</span>
                <v-btn icon small class="ml-2" :disabled="orderNoBalance()" @click="editarMonto" title="Escribir el monto"><v-icon>mdi-pencil-outline</v-icon></v-btn>
              </div>
              <div v-else class="teclado__monto-fila">
                <ng-number-keyboard label="amount" v-model="montoManual" :filled="false" :dense="true" hide-details autofocus
                  prefix="$" class="teclado__monto-campo" :nudgetTop="0"></ng-number-keyboard>
                <v-btn icon small class="ml-2" color="primary" @click="editandoMonto = false" title="Listo"><v-icon>mdi-check</v-icon></v-btn>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="ma-0" v-if="paymentMethod.manage_change">
            <v-alert color="green" dark outlined dense class="ma-0">
              <v-row class="green--text">
                <v-col class="text-left">
                  <span class="title font-weight-medium">{{ $t('change') }}: </span>
                </v-col>
                <v-col class="text-right">
                  <span class="title font-weight-regular">
                    {{ $filters.currency(cambioVisible, 0) }}
                  </span>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
        </v-row>
        <v-row class="px-1 mt-0">
          <v-col cols="8">
            <v-btn color="green" class="white--text boton-pago-completo" :disabled="orderNoBalance()" block elevation="0"
              :title="$t('full_payment')" large @click="payComplete()">{{ $t('full_payment') }}</v-btn>
          </v-col>
          <v-col>
            <v-btn color="primary" :disabled="totalPayment < 1 || order.getBalance() == 0" block elevation="0" large
              @click="addPayment()">
              <v-icon>mdi-check-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- «Pago completo» y «Recibe en efectivo» registran con un toque: antes se confirma el medio, para que un pago con
         tarjeta no quede en efectivo por no cambiar de pestaña (PLAN-ASEGURAR-POS.md, 1.8). -->
    <v-dialog v-model="confirmando" max-width="420" persistent content-class="confirmar-medio">
      <v-card>
        <v-card-title class="text-h6">Confirmar el pago</v-card-title>
        <v-card-text class="text-body-1">
          ¿Registrar <strong>{{ $filters.currency(valorPorConfirmar, 0) }}</strong> en
          <strong class="confirmar-medio__medio">{{ paymentMethod.name }}</strong>?
          <div v-if="paymentMethod.manage_change && change > 0" class="mt-2">
            Recibe {{ $filters.currency(totalPayment, 0) }} · cambio <strong>{{ $filters.currency(change, 0) }}</strong>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancelarConfirmacion" id="btn-cambiar-medio">Cambiar</v-btn>
          <v-spacer></v-spacer>
          <v-btn ref="btnConfirmar" color="primary" elevation="0" large @click="confirmarMedio" id="btn-confirmar-medio">
            Registrar en {{ paymentMethod.name }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const DEFAULT_ITEM = { id: '', name: '', last_name: '', email: '', identification: '', phone: '', address: '' };
export default {
  name: 'CartPaymentsKeyboard',
  data: () => ({
    isPayCard: true,
    searched: false,
    totalPayment: 0,
    positiveBalance: 0,
    reference: null,
    change: 0,
    editandoMonto: false,
    confirmando: false
  }),
  props: {
    paymentMethod: {
      type: Object,
      default: null,
    },
    order: Object,
    is_mobile: Boolean
  },
  //props: ['customer'],

  mounted() {
    /*if(this.customer){
      setTimeout(() => {


      this.item = JSON.parse(JSON.stringify(this.customer));
      this.searched = true;
      this.key++;
      }, 250)
    }*/
  },
  computed: {
    // El cambio de un cobro ya registrado se ve hasta cerrar; con saldo por cobrar y sin monto, no hay cambio.
    // El monto escrito a mano (efectivo recibido u otro valor): texto del campo <-> número del pago.
    montoManual: {
      get() {
        return this.totalPayment ? String(this.totalPayment) : "";
      },
      set(v) {
        this.totalPayment = parseFloat(String(v).replace(/[^0-9.]/g, "")) || 0;
        if (this.paymentMethod.manage_change) {
          this.calculateChange();
        }
      },
    },
    // Lo que de verdad se registra: nunca más que el saldo (el resto es cambio).
    valorPorConfirmar() {
      return Math.min(this.totalPayment, this.order.getBalance());
    },
    cambioVisible() {
      return this.totalPayment > 0 || this.order.getBalance() == 0 ? this.change : 0;
    },
    // Billetes y monedas útiles para ir sumando lo que entrega el cliente.
    billetes() {
      return [1000, 2000, 5000, 10000, 20000, 50000, 100000];
    },
    // «Exacto» y los billetes redondos que cubren el saldo (para $1.425.000: exacto, 1.430.000, 1.440.000, 1.450.000).
    sugeridos() {
      const saldo = Math.round(this.order.getBalance());
      if (!(saldo > 0)) return [];
      const lista = [saldo];
      for (const d of [5000, 10000, 20000, 50000, 100000]) {
        const v = Math.ceil(saldo / d) * d;
        if (v > saldo && !lista.includes(v)) lista.push(v);
      }
      return lista.slice(0, 4);
    },
  },
  methods: {
    editarMonto() {
      this.editandoMonto = true;
    },
    addTotalPayment(paymentMethod, value) {
      this.totalPayment += value;
      if (paymentMethod.manage_change) {
        this.calculateChange();
      }
    },
    async addPayment() {
      // Sin saldo o sin monto no hay pago: un clic repetido no debe dejar pagos de $0 en el pedido.
      if (!(this.order.getBalance() > 0) || !(this.totalPayment > 0)) {
        this.totalPayment = 0;
        return;
      }
      // La referencia (voucher, transferencia) es obligatoria en los medios que la piden: «Pago completo» y los billetes
      // sugeridos registran con un toque y la dejaban vacía.
      if (this.paymentMethod.need_reference && !String(this.reference || "").trim()) {
        this.totalPayment = 0;
        this.$store.commit("setError", "Escribe la referencia del pago con " + this.paymentMethod.name + " antes de registrarlo.");
        return;
      }
      let value = this.totalPayment;
      if (this.totalPayment > this.order.getBalance()) {
        value = this.order.getBalance();
      }
      let turn = this.$store.getters.turn;
      this.$pos.addPayment(
        this.order,
        {
          _id: new Date().getTime(),
          payment_method: this.paymentMethod,
          date: this.$filters.datetime((new Date())),
          value: value,
          acc_income_id: null,
          reference: this.reference,
          bill_cash_register_id: this.order.getBillCashRegisterId(),
          bill_cash_register_turn_id: turn.id,
          change: this.change
        });
      this.totalPayment = 0;
      // Cada pago lleva su comprobante: si no, el segundo pago del mismo medio repetía el del primero.
      this.reference = null;
    },
    calculateChange() {
      const change = this.totalPayment - this.order.getBalance();
      if (change < 0) {
        this.change = 0;
      } else {
        this.change = change;
      }

    },
    cleanTotalPayment(paymentMethod) {
      this.totalPayment = 0;
      if (paymentMethod.manage_change) {
        this.calculateChange();
      }
    },
    // «Pago completo»: registra de una vez lo que falta (sin pasar por el visto), después de confirmar el medio.
    payComplete() {
      this.totalPayment = this.order.getBalance();
      if (this.paymentMethod.manage_change) {
        this.calculateChange();
      }
      this.pedirConfirmacion();
    },
    // Lo que el cliente entrega en efectivo (un valor sugerido): se registra, tras confirmar, y queda el cambio a la vista.
    recibir(valor) {
      this.totalPayment = valor;
      this.calculateChange();
      this.pedirConfirmacion();
    },
    // La referencia se pide antes de preguntar: confirmar y luego enterarse de que falta era un paso perdido.
    pedirConfirmacion() {
      if (!(this.order.getBalance() > 0) || !(this.totalPayment > 0)) {
        this.totalPayment = 0;
        return;
      }
      if (this.paymentMethod.need_reference && !String(this.reference || "").trim()) {
        this.totalPayment = 0;
        this.$store.commit("setError", "Escribe la referencia del pago con " + this.paymentMethod.name + " antes de registrarlo.");
        return;
      }
      this.confirmando = true;
      // Enter confirma: el foco va al botón cuando el diálogo termina de abrir.
      setTimeout(() => {
        const b = this.$refs.btnConfirmar;
        if (this.confirmando && b && b.$el) b.$el.focus();
      }, 150);
    },
    async confirmarMedio() {
      if (!this.confirmando) return;
      this.confirmando = false;
      await this.addPayment();
    },
    cancelarConfirmacion() {
      this.confirmando = false;
      this.totalPayment = 0;
      if (this.paymentMethod.manage_change) {
        this.calculateChange();
      }
    },
    cancel() {
      this.clear();
      this.searched = false;
      this.key++;
      this.$emit('cancel');
    },
    orderNoBalance() {
      if (this.order.getBalance() == 0) {
        return true;
      }
      return false;
    }
  }
}
</script>
<style>
.teclado__titulo {
  display: block;
  margin: 0 0 6px 4px;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(0, 0, 0, 0.6);
}
.teclado__sugeridos {
  padding: 0 4px 10px;
}
.teclado__fila {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));
  gap: 8px;
}
.teclado__fila .v-btn {
  font-weight: 700;
  letter-spacing: 0;
}
.teclado__billetes {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 0 4px;
}
.teclado__billetes .v-btn {
  min-width: 0 !important;
  padding: 0 4px !important;
}
.teclado__sug-btn.v-btn {
  height: auto !important;
  min-height: 52px;
  padding: 6px 4px !important;
}
.teclado__sug {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.25;
}
.teclado__sug-valor {
  font-size: 1rem;
  font-weight: 700;
}
.teclado__sug small {
  font-size: 0.68rem;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  opacity: 0.85;
}
.teclado__monto-fila {
  display: flex;
  align-items: center;
  min-height: 36px;
}
.teclado__monto-campo {
  flex: 1 1 auto;
}
.teclado__monto-campo input {
  font-size: 1.25rem;
  font-weight: 600;
}
</style>
